import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';

let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json');
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';


export async function getDetailByFilter(data) {
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/subscription/getdetails`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getSubscriptionById(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/subscription/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function updateSubscription(data) {
    try {
        const response = await serviceContext.put(`${BASE_URL_M_ADMIN}madmin/subscription`, JSON.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}